import { render, staticRenderFns } from "./GradeManager.vue?vue&type=template&id=6396a7c7&scoped=true&"
import script from "./GradeManager.vue?vue&type=script&lang=js&"
export * from "./GradeManager.vue?vue&type=script&lang=js&"
import style0 from "./GradeManager.vue?vue&type=style&index=0&id=6396a7c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396a7c7",
  null
  
)

export default component.exports